<template>
  <div class="filter-container">
    <b-row class="d-flex justify-content-between align-items-center mx-1">
      <div class="d-flex flex-row">
        <h4>
          <template v-if="loading">{{ $t('general.loading') }}</template>
          <template v-else>{{ $tc('manage.total-results', total) }}</template>
        </h4>
      </div>
      <div class="d-flex flex-row" v-if="!hideWhere || !hideOrderBy">
        <slot name="order"/>
        <toggle-filters v-if="!hideWhere" class="py-1 px-3" v-model="showWhereFilters"/>
      </div>
    </b-row>

    <b-card class="my-3" v-if="showWhereFilters">
      <slot name="where"/>
    </b-card>

    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner type="grow" variant="primary"/>
    </div>

    <template v-else-if="results">
      <template v-if="total">
        <slot name="before"/>
        <b-row class="mt-3 row-cols-1 row-cols-md-2" v-if="Array.isArray(results.edges)">
          <template v-for="{ entry } in results.edges">
            <b-col v-if="entry && entry.id" :key="entry.id" v-bind="colProps" class="mb-3">
              <slot name="item" v-bind="{ entry }">
                <b-card>{{ entry.fullName || entry.name || entry.title || entry.id }}</b-card>
              </slot>
            </b-col>
          </template>
        </b-row>
        <slot name="after"/>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <p v-if="page && totalPages">{{ $t('manage.page-n-of-t', { page, totalPages }) }}</p>
          <slot name="pagination"/>
        </div>
      </template>
      <div class="mt-3" v-else>
        <p class="text-center">{{ $tc('manage.total-results', 0) }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import ToggleFilters from '@/components/misc/ToggleFilters';

export default {
  name: 'FilterContainer',
  props: {
    cols: {
      type: [ Number, String ],
      default: 2,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideWhere: {
      type: Boolean,
      default: false,
    },
    hideOrderBy: {
      type: Boolean,
      default: false,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
    order: {
      type: String,
      default: null,
    },
    orderByEnums: {
      type: Object,
      default: null,
    },
    results: {
      type: Object,
      default: () => ({
        edges: [],
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
      }),
    },
  },
  components: {
    ToggleFilters,
  },
  data: () => ({
    showWhereFilters: false,
  }),
  created() {
    this.showWhereFilters = this.showFilters === true;
  },
  computed: {
    colProps() {
      switch (parseInt(this.cols, 10)) {
        case 4: return { cols: 12, sm: 6, md: 3 };
        case 3: return { cols: 12, sm: 6, md: 4 };
        case 2: return { cols: 12, sm: 6 };
        default: return { cols: 12 };
      }
    },
    page() {
      const { page } = this.results || {};
      return page || 1;
    },
    limit() {
      const { limit } = this.results || {};
      return limit || 10;
    },
    total() {
      const { total } = this.results || {};
      return total || 0;
    },
    totalPages() {
      const { limit, total, totalPages } = this.results || {};
      if (typeof totalPages === 'number') {
        return totalPages || 1;
      } else if (typeof limit === 'number' && typeof total === 'number') {
        return limit < total ? Math.ceil(total / (limit || 1)) || 1 : 1;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterContainer.vue